export const platformVersion = '^19.1.0';
